import React from "react";

import ApplicationLayout, { applicationStyles as styles } from "./ApplicationLayout";
import GoldSpinner from "../../assets/Spinner/GoldSpinner";

// Shown from the moment Instagram sends the member back until their photos are displayed
const CheckingInstagram = ({ onRetry }) => (
  <ApplicationLayout centred>
    <div className={styles.centred} role="status">
      <GoldSpinner />
      <h1 className={styles.title} style={{ margin: "8px 0 0", fontSize: 28 }}>
        Checking your Instagram
      </h1>
      <p className={styles.intro} style={{ margin: 0 }}>
        This usually takes a few seconds. Please keep this page open.
      </p>
      <p className={styles.footerNote}>
        Taking longer than a minute?{" "}
        <button type="button" className={styles.link} onClick={onRetry}>
          Try again
        </button>
      </p>
    </div>
  </ApplicationLayout>
);

export default CheckingInstagram;
